export default __webpack_public_path__ + "static/media/parachute-logo-with-text-4x.90571a0c.png";